module.exports = __webpack_public_path__ + "img/jiankong.1ada839e.png";